import dayjs from 'dayjs';
import _ from 'underscore';
import parseError from '../../parseError.js';
import { Toast } from '../../../../../Notification/index.js';

export const logStart = async ({userId, GTitle, day, logJobStart}) => {
  const operation = 1; // 1 = create/update
  try {
    await logJobStart(userId, operation);
  }
  catch(error) {
    if (!_.isEmpty(error)) {
      console.log(error);
      let notification = {
        type: 'error',
        message: "Logging Job Start Error",
        description: `For [${GTitle} on ${day}]: ${parseError(error)}`
      };
      Toast(notification);
    }
  }
}

export const logFinish = async ({GTitle, logControlId, jobId, day, logJobFinish}) => {
    try {
      await logJobFinish(logControlId, jobId);
    }
    catch(error) {
      if (!_.isEmpty(error)) {
        console.log(error);
        let notification = {
          type: 'error',
          message: "Logging Job Finish Error",
          description: `For [${GTitle} on ${day}]: ${parseError(error)}`
        };
        Toast(notification);
      }
    }
}


export const updateJobElement = async ({ finalFormValidation, jobElement, logControlId, state, userId, updateState, editJobElement, refreshPage }) => {
  if (!finalFormValidation()) {
    return null;
  }
  const { id, jobId, tourId, resourceId, executingBranchId, serviceId, relatedServiceId,
  status, startRequest, endRequest, startActual, endActual, timeZoneId, orderingUserId, descriptionComment,
  approverComment, employeeComment, schedulerComment, isAnUpgrade, overTime, activityType,
  overTimeType, overTimeReason, jobSalaryUpgradeId, hourlyActivityRateFlag, rate
  } = jobElement;
  const { itemDetails } = state;
  const { costObject } = itemDetails;
  const { costObjectId, costObjectTypeId } = costObject;
  const parameters = {
    assignmentId: id,
    jobId,
    tourId,
    resourceId,
    executingBranchId,
    serviceId,
    relatedServiceId,
    status,
    startRequest,
    endRequest,
    startActual,
    endActual,
    timeZoneId,
    orderingUserId,
    updatingUserId: itemDetails.updatingUserId,
    descriptionComment: descriptionComment,
    approverComment: approverComment,
    employeeComment: employeeComment,
    schedulerComment: schedulerComment,
    isAnUpgrade,
    logControlId,
    overTime,
    activityType,
    overTimeType: overTimeType || 0,
    overTimeReason : overTimeReason,
    costObjectId, // only things changed
    costObjectTypeId, // changed things changed
    jobSalaryUpgradeId,
    hourlyActivityRateFlag,
    rate,
  };

     // store assignment parameters for optimistic re-ender
     itemDetails.assignmentParams = parameters;
     await updateState({itemDetails});
    // update job element
    const date = dayjs(startActual).format('M/D/YYYY (ddd)');
    let notification = {type: 'success', message: 'Assignment Updated', description: `For resourceId: ${resourceId} on ${date}`};
    try {
      await editJobElement(parameters);
    }
    catch(error) {
      if (!_.isEmpty(error)) {
        updateState({
          crudError: {
            failedAction: 'editJobElement',
            message: parseError(error)
          }
        });
        console.log(error);
        notification = {
            type: 'error',
            message: "Updating Assignment Failed",
            description: `For [resourceId: ${resourceId} on ${date}]: ${parseError(error)}`
          };
        }
    }
    Toast(notification);
    // no need to refresh here, will be handled by updateJob below
}


export const updateJob = async ({ finalFormValidation, logControlId, state, userId, updateState, editJob, refreshPage }) => {
  if (!finalFormValidation()) {
    return null;
  }
  const { itemDetails } = state;
  const { jobId, name, jobNumber, creatingUserId, updatingUserId, costObject, GTitle,
    GSchedulerComments, baseDate, startRequest, endRequest, GAdditionalInformation
  } = itemDetails;
  const { costObjectId, costObjectTypeId } = costObject;
  let { jobBaseDate } = itemDetails;

  const parameters = {
    jobId,
    name: GTitle,
    jobNumber,
    creatingUserId,
    updatingUserId,
    costObjectId,
    costObjectTypeId,
    GTitle,
    GSchedulerComments: GSchedulerComments || null,
    baseDate: dayjs(jobBaseDate).format('YYYY-MM-DD') + 'T00:00:00.000Z',
    startRequest,
    endRequest,
    GAdditionalInformation: GAdditionalInformation || null,
    logControlId
  };

    // update job
    const date = dayjs(jobBaseDate).format('M/D/YYYY (ddd)');
    let notification = {type: 'success', message: ' Request Updated', description: `For ${GTitle} on ${date}`};
    try {
      await editJob(parameters);
    }
    catch(error) {
      if (!_.isEmpty(error)) {
        updateState({
          crudError: {
            failedAction: 'editJob',
            message: parseError(error)
          }
        });
        console.log(error);
        notification = {
            type: 'error',
            message: "Updating Request Failed",
            description: `For [${GTitle} on ${date}]: ${parseError(error)}`
          };
        }
    }
    Toast(notification);
    updateState({
      crudLoading: false // allows page refresh after updateJob completes
    });
    refreshPage();
}

